// @ts-nocheck
import React, { FC, useEffect, useMemo, useState } from 'react';
import { whichAuth as getAuth } from '../../getAuth';
import { userState } from '../../atoms';
import { useRecoilValue } from 'recoil';
import { cardOutline } from 'ionicons/icons';
import CurrencyFormat from 'react-currency-format';
import { PaymentInfo, AlertModal, WrapperFilterSort, UserSearch } from '../../components';
import { handleErrors } from '../../utils/handleErrors';
import {REST_API_URL} from '../../constants/global';
import {
  IonCol,
  IonGrid,
  IonItem,
  IonRow,
  IonImg,
  IonIcon,
  IonText,
  IonPage,
  IonContent,
  IonProgressBar,
} from '@ionic/react';
import { PageProps } from "../../Page.model";
import './Payments.css'
import { registerables, Chart } from "chart.js";
import { Chart as ChartJS } from 'react-chartjs-2';
import { OptionProps } from "../../components/WrapperFilterSort/WrapperFilterSort.model";
import { SortPropsTitlePayment, SortPropsPayment } from "./Payment.model";
import ArrowRightIcon from "../../assets/arrow-right-bills.svg";
import { format } from "date-fns";
import cn from "classnames";

const configSort: Record<SortPropsTitlePayment, { [key: string]: SortPropsPayment, initialValue: SortPropsPayment }> = {
  [ SortPropsTitlePayment.Date] :
    {
      [SortPropsPayment.DateAsc]: SortPropsPayment.DateDesc,
      [SortPropsPayment.DateDesc]: SortPropsPayment.DateAsc,
      initialValue: SortPropsPayment.DateAsc
    },
  [ SortPropsTitlePayment.Provider] :
    {
      [SortPropsPayment.ProviderAsc]: SortPropsPayment.ProviderDesc,
      [SortPropsPayment.ProviderDesc]: SortPropsPayment.ProviderAsc,
      initialValue: SortPropsPayment.ProviderAsc
    },
  [ SortPropsTitlePayment.Amount] :
    {
      [SortPropsPayment.AmountAsc]: SortPropsPayment.AmountDesc,
      [SortPropsPayment.AmountDesc]: SortPropsPayment.AmountAsc,
      initialValue: SortPropsPayment.AmountAsc
    },
}

const Payments: FC<PageProps> = ({ show }) => {
  
  const user = useRecoilValue(userState);

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = React.useState([]);
  const [userBalance, setUserBalance] = React.useState(0);
  const [sort, setSort] = useState<OptionProps | null>(null)
  const [options, setOptions] = useState<OptionProps[]>([
    { value: SortPropsPayment.DateAsc, title: SortPropsTitlePayment.Date },
    { value: SortPropsPayment.ProviderAsc, title: SortPropsTitlePayment.Provider },
    { value: SortPropsPayment.AmountAsc, title: SortPropsTitlePayment.Amount },
  ])
  const [searchFilter, setSearchFilter] = useState<string>('');
  const [paymentList, setPaymentList] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [searchUser, setSearchUser] = useState(null);
  
  Chart.register(...registerables);

  const getPayments = () => {
    setIsLoading(true);
    setUserBalance(searchUser ? searchUser.paymentInfo.balance : user.paymentInfo.balance);
    const uri = searchUser ? searchUser._links?.payments.href
      : user.admin ? REST_API_URL+'/payments' : user?._links?.payments.href;
    getAuth().currentUser.getIdToken().then(token => {
      fetch(uri + '?sort=date,desc', {headers: {'Authorization': 'Bearer ' + token}})
        .then(handleErrors)
        .then(payments => setData(payments._embedded.payments
          .map(payment => ({
              ...payment,
              amount: payment.amount/100
            }
          ))))
        .catch(() => setError('Failed to retrieve your payment history.'))
        .finally(() => setIsLoading(false))
    })
  }

  const sequenceStartBalance = () => chartData.reduce((balance,amount) => balance - amount, (userBalance/100));
  
  const getDatasets = () => {
    const datasets = [
      {
        label: 'Payment',
        type: 'bar' as const,
        data: chartData,
        borderWidth: 0,
        borderRadius: 5,
        backgroundColor: chartData.map(amount => amount > 0 ? '#6572f5' : '#ffd534'),
      }];
    if((!user.admin || searchUser) && !searchFilter && (!sort || sort?.value === SortPropsPayment.DateDesc)) {
      datasets.push({
        label: 'Balance',
        type: 'line' as const,
        data: chartData.map((amount,index) => chartData.slice(0,index+1).reduce((balance,amount) => balance + amount, sequenceStartBalance())),
        borderWidth: 1,
        borderColor: 'grey',
        tension: .3,
        display: false
      });
    }
    return datasets;
  }
  
  const getLabels = () => {
    const labels = paymentList.map(payment => payment.provider ? payment.provider.name : 'Repayment');
    labels.reverse();
    return labels;
  }
  
  useEffect(() =>
    setPaymentList(searchFilter ? data?.filter((item) => item?.provider?.name?.toLowerCase().includes(searchFilter.toLowerCase())) : data),
    [data, searchFilter]);
  
  useEffect(() => {
    const chartData = paymentList.map(payment => payment.amount);
    chartData.reverse();
    setChartData(chartData)
  }, [paymentList, sort]);
  
  useEffect(getPayments, [searchUser]);

  useEffect(() => {
    show && getPayments()
    setSearchFilter('')
    setSort(null)
  }, [show]);

  useEffect(() => {
    if (!sort) return
    setOptions(state => state.map(item => {
      return {
        ...item,
        value: sort.title === item.title ? configSort[item.title][item.value] : configSort[item.title].initialValue ,
      }
    }))
  }, [sort])

  return (
    show &&
      <IonPage>
        <PaymentInfo />
        { user.admin && <UserSearch onSelect={searchUser => setSearchUser(searchUser)} /> }
        
        {isLoading && !!paymentList ? (
          <IonContent><IonProgressBar type="indeterminate" /></IonContent>
        ) : (
          <IonContent className="bills-content">
            
            <WrapperFilterSort
              configSort={configSort}
              setSearchFilter={(filterItem) => setSearchFilter(filterItem)}
              data={data}
              options={options}
              setSort={(sortItem) => setSort(sortItem)}
              sort={sort}
            />
            
            { paymentList?.length > 1 &&
              <div className="chart">
              <ChartJS
                type={'bar'}
                legend = {{ display: false }}
                options = {{
                  maintainAspectRatio: false,
                  scales:{ x: { display: false }},
                  elements: {point: { radius: 1 }},
                  plugins: {legend: { display: false }}
                }}
                data={{
                  datasets: getDatasets(),
                  labels: getLabels()
                }}
              />
              </div>
            }
            
            {!paymentList?.length ?
              <IonRow><div className="settings-col-title no-available">No payment data available.</div></IonRow> :
              paymentList?.sort((a, b) => {
                  if (sort?.value === SortPropsPayment.ProviderDesc) {
                    return a.provider?.name.toLowerCase() > b.provider?.name.toLowerCase() ? -1 : 1;
                  } else if (sort?.value === SortPropsPayment.ProviderAsc) {
                    return a.provider?.name.toLowerCase() > b.provider?.name.toLowerCase() ? 1 : -1;
                  } else if (sort?.value === SortPropsPayment.AmountDesc) {
                    return a.amount > b.amount ? -1 : 1;
                  } else if (sort?.value === SortPropsPayment.AmountAsc) {
                    return a.amount > b.amount ? 1 : -1;
                  } else if (sort?.value === SortPropsPayment.DateDesc) {
                    a = new Date(a.date);
                    b = new Date(b.date);
                    return a > b ? -1 : 1;
                  } else if (sort?.value === SortPropsPayment.DateAsc) {
                    a = new Date(a.date);
                    b = new Date(b.date);
                    return a > b ? 1 : -1;
                  }
                }
              )?.map((item) => (
                <IonItem
                  detail
                  id={item?.id}
                  key={item?.id}
                  detailIcon={ArrowRightIcon}
                  className="bills-content-item"
                >
                  { item?.provider?.logo ?
                    <IonImg src={item?.provider?.logo} className="bills-content-icon" />
                    :
                    <IonIcon icon={cardOutline} color="primary" className="bills-content-icon-card" />
                  }
                  <IonGrid>
                    <IonRow className="bills-content-item-wrapper">
                      <IonCol size="12" className="bills-content-header-wrapper">
                        { item?.provider ? 
                          <div>
                            <div className="bills-content-title">{item?.provider?.name}</div>
                            <IonText className="bills-content-subtitle">
                              {format(new Date(item?.date), 'dd MMM yyyy')} <IonText className="bills-content-subtitle-hidden">| {item?.provider?.service}</IonText>
                            </IonText>
                          </div>
                          :
                          <div>
                            <div className="bills-content-title">{user.admin ? 'User payment' : user.name}</div>
                            <IonText className="bills-content-subtitle">
                              {format(new Date(item?.date), 'dd MMM yyyy')} <IonText className="bills-content-subtitle-hidden">| Payment</IonText>
                            </IonText>
                          </div>
                        }
                        <div className="bills-content-wrapper-subtitle">
                          <div className="bills-content-wrapper-credit">
                            <CurrencyFormat
                              value={item?.amount}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              prefix='$'
                              displayType='text'
                              className={cn("bills-content-title", { 'debit': item?.amount < 0 })}
                            />
                          </div>
                        </div>
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                </IonItem>
              ))}
          </IonContent>
        )}
        <AlertModal
          isOpen={isOpenModal}
          title="Failed to retrieve your payment history"
          onClosed={() => setIsOpenModal(false)}
        />
      </IonPage>
  );
}

export default Payments;
